import { cn } from "@/lib/cn";

interface LoadingStateProps {
  label?: string;
  rows?: number;
  className?: string;
}

export const LoadingState = ({ label, rows = 5, className }: LoadingStateProps) => (
  <div data-testid="loading-state" className={cn("space-y-2 p-4", className)}>
    {label && <p className="ops-label mb-3">{label}</p>}
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        className="h-8 animate-pulse rounded-sm bg-[hsl(var(--surface-raised))]"
        style={{ animationDelay: `${i * 60}ms` }}
      />
    ))}
  </div>
);
